// extracted by mini-css-extract-plugin
export default {"container":"Input_container__ZS8w-","label":"Input_label__d9q9S","error":"Input_error__z2XLG"};